<template>
  <v-data-table
      :headers="fields"
      :items="lignes"
      :loading="isLoading"
      class="elevation-2"
      dense
      disable-sort
      locale="fr-FR"
      no-results-text="Aucun article trouvé"
      :items-per-page="50"
      :items-per-page-options="[20, 50, 100, -1]"
      :footer-props="{
                'items-per-page-text': 'Lignes par pages:',
                'page-text': '{0}-{1} sur {2}',
                'items-per-page-all-text': 'Toutes',
                'items-per-page': 20,
                'items-per-page-options': [20, 50, 100, -1]
              }"
  >

    <template v-slot:item.softId="{ item }">
      <span>{{ item.ligne.articleSoftId }}</span>
    </template>

    <template v-slot:item.designation="{ item }">
      <span>{{ item.ligne.designation }}</span>
    </template>

    <template v-slot:item.quantite_mouvement="{ item }">
      <span>{{ item.quantiteMouvement }}</span>
    </template>

    <template v-slot:item.aRetroceder="{ item }">
      <span>{{ labelRetrocession(item.aRetroceder) }}</span>
    </template>

    <template v-slot:item.paiementDate="{ item }">
      <span>{{ item.paiementDate | moment("DD/MM/YYYY") }}</span>
    </template>

    <template v-slot:item.montantRetrocession="{ item }">
      <span>{{ item.montantRetrocession }} €</span>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: 'AffichageLigneRetrocession',
  props: {
    lignes: {},
    fields: {},
    isLoading: {}
  },
  data () {
    return {}
  },
  methods: {
    labelRetrocession(value){
      let retour = null;
      if(value === false){
        retour = 'Oui'
      } else {
        retour = 'Non'
      }

      return retour;
    }
  }
}
</script>

<style scoped>

</style>
